import { gql } from 'glimmer-apollo';

export const GET_ARTICLE = gql`
  query ($slug: String) {
    articles: articleCollection(limit: 1, where: { slug: $slug }) {
      items {
        title
        slug
        publishedDate
        previewText
        primaryTag
        tags
        author {
          name
          avatar {
            url
          }
        }
        image {
          url
          description
        }
        content
      }
    }
  }
`;
